import { Observable, of } from 'rxjs';

import { ConditionReport, conditionReportSearchSelectors, conditionReportSelectors, ConditionReportState } from '@skinsoft/entity/src/condition-report';
import { getReadableDate } from '@skinsoft/ui';

export interface ReportFeatured {
    id: string
    associatedMedias: string[]
    firstMedia: string
    referenceNumber: string
    technicsAndMaterials: string
    originalIdentifier: string
    reportReason: string
    location: string
    date: string
    generalState: string
    recommendations: string
    state: ConditionReportState
    involvedItem: string;
    comments: string
}

export function toReportFeatured$(report: ConditionReport, locale: string): Observable<ReportFeatured> {

    const featuredReport: ReportFeatured = {
        associatedMedias: conditionReportSelectors.medias(report),
        comments: conditionReportSelectors.comments(report, locale),
        date: getReadableDate(conditionReportSelectors.date(report)),
        firstMedia: conditionReportSelectors.firstMedia(report),
        generalState: conditionReportSelectors.generalState(report, locale),
        id: conditionReportSelectors.id(report),
        involvedItem: conditionReportSelectors.involvedItem(report),
        location: conditionReportSelectors.location(report, locale),
        originalIdentifier: conditionReportSelectors.technicsAndMaterials(report, locale),
        recommendations: conditionReportSelectors.recommendations(report, locale),
        referenceNumber: conditionReportSelectors.referenceNumber(report),
        reportReason: conditionReportSelectors.reportReason(report, locale),
        state: conditionReportSelectors.workflowState(report) as ConditionReportState,
        technicsAndMaterials: conditionReportSelectors.technicsAndMaterials(report, locale),
    }

    return of(featuredReport);

}

export function toReportFeaturedFromSearch$(report: ConditionReport, locale: string): Observable<ReportFeatured> {

    const featuredReport: ReportFeatured = {
        associatedMedias: conditionReportSearchSelectors.medias(report),
        comments: conditionReportSearchSelectors.comments(report, locale),
        date: getReadableDate(conditionReportSearchSelectors.date(report)),
        firstMedia: conditionReportSearchSelectors.firstMedia(report),
        generalState: conditionReportSearchSelectors.generalState(report, locale),
        id: conditionReportSearchSelectors.id(report),
        involvedItem: conditionReportSearchSelectors.involvedItem(report),
        location: conditionReportSearchSelectors.location(report, locale),
        originalIdentifier: conditionReportSearchSelectors.technicsAndMaterials(report, locale),
        recommendations: conditionReportSearchSelectors.recommendations(report, locale),
        referenceNumber: conditionReportSearchSelectors.referenceNumber(report),
        reportReason: conditionReportSearchSelectors.reportReason(report, locale),
        state: conditionReportSearchSelectors.workflowState(report) as ConditionReportState,
        technicsAndMaterials: conditionReportSearchSelectors.technicsAndMaterials(report, locale),
    }
    return of(featuredReport);

}

